import * as React from 'react';
import { useQuery } from '@tanstack/react-query';
import { SegmentAttributeBase, SegmentAttributeCategory } from '../models/segments';
import { AppContext, AppProviderDispatch } from '../shared/app-context';
import useRestService from '../shared/rest-service';
import { mapTransactionalAttributes } from '../utilities/attribute-filter';

/**
 * Hook to retrieve and cache client-specific segment attribute metadata via React Query
 */
const useSegmentAttributes = () => {
  const appState = React.useContext<AppProviderDispatch>(AppContext);
  const { fetchWrapper } = useRestService();

  return useQuery<
    SegmentAttributeCategory[],
    Error,
    { categories: SegmentAttributeCategory[]; attributes: SegmentAttributeBase[] }
  >(
    ['segment-attributes', appState.state.clientId],
    () => {
      return fetchWrapper(`api/${appState.state.clientId}/attributes`);
    },
    {
      staleTime: Infinity,
      select: (data) => {
        // map attributeId to id
        const mappedData = data.map((attributeCategory) => {
          return {
            category: attributeCategory.category,
            attributes: mapTransactionalAttributes(attributeCategory.attributes)
          };
        });

        return {
          categories: mappedData,
          attributes: mappedData.reduce((prev, cur) => [...prev, ...cur.attributes], [])
        };
      }
    }
  );
};

export default useSegmentAttributes;
